import React, { useState } from 'react';

const VideoSection: React.FC<{ videoUrl: string; thumbnailUrl: string }> = ({ videoUrl, thumbnailUrl }) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const toggleVideo = () => {
    setIsVideoPlaying((prev) => !prev);
  };

  return (
    <div className='video_section_wrapper' style={{ margin:'30px', maxWidth: '400px' }}>
      {isVideoPlaying ? (
        <video controls width="400" height="300">
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img src={thumbnailUrl} width="400" alt="Video Thumbnail" onClick={toggleVideo} />
      )}

      <div className='howToWear'>
        <h2>How to wear Contact Lenses?</h2>
        <p>Choosing Aqualens made easier</p>
      </div>
    </div>
  );
};

export default VideoSection;


// import React, { useState, useRef } from 'react';

// const VideoSection: React.FC<{ videoUrl: string; thumbnailUrl: string }> = ({ videoUrl, thumbnailUrl }) => {
//   const [isVideoPlaying, setIsVideoPlaying] = useState(false);
//   const videoRef = useRef<HTMLVideoElement | null>(null);

//   const toggleVideo = () => {
//     const video = videoRef.current;
//     if (video) {
//       if (isVideoPlaying) {
//         video.pause();
//       } else {
//         video.play();
//       }
//     }
//     setIsVideoPlaying((prev) => !prev);
//   };

//   return (
//     <div>
//       {isVideoPlaying ? (
//         <video ref={videoRef} controls width="400" height="300" onClick={toggleVideo}>
//           <source src="https://cdn.shopify.com/videos/c/o/v/da5fed448d224a6dae7dd3e29401a84d.mp4" type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//       ) : (
//         <div>
//           <img src="https://www.youtube.com/embed/boLCg6kZ7fA?rel=0&modestbranding=0&autoplay=0&loop=0"alt="Video Thumbnail" onClick={toggleVideo} />
//           <div
//             style={{
//               position: 'absolute',
//               top: '50%',
//               left: '50%',
//               transform: 'translate(-50%, -50%)',
//               fontSize: '24px',
//               color: 'white',
//               cursor: 'pointer',
//             }}
//             onClick={toggleVideo}
//           >
//             ▶️
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default VideoSection;


